import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { buildSearchParams } from "@/lib/queryParams";

export function useStringQueryParamState(key: string, defaultValue: string) {
  const [searchParams, setSearchParams] = useSearchParams();

  const value = searchParams.get(key) || defaultValue;

  const setValue = useCallback(
    (nextValue: string) => {
      setSearchParams(
        (prev) => buildSearchParams(prev, { [key]: nextValue === defaultValue ? undefined : nextValue }, []),
        { replace: true },
      );
    },
    [defaultValue, key, setSearchParams],
  );

  return [value, setValue] as const;
}
